
const list = {
  path: 'list',
  component: resolve => require(['../../../../../pages/modules/news/list'], resolve),
}

export default list
